import script from "./AppNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNotification.vue?vue&type=script&setup=true&lang=js"

import "./AppNotification.vue?vue&type=style&index=0&id=9101d25e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9101d25e"]])

export default __exports__